const interval = setInterval(() => {
  if (window.Chart) {
    clearInterval(interval);
    Chart.register({
      id: "center",
      afterDatasetsDraw: function (chart, e) {
        if (chart.config.options?.plugins?.center?.title) {
          let n;
          const ctx = chart.ctx;
          const centerConfig = chart.config.options.plugins.center.title;
          const fontStyle = centerConfig.fontStyle || "Rubik";
          const txt = centerConfig.text;
          const color = centerConfig.color || "#000";
          const stringWidth = ctx.measureText(txt).width;

          const lineHeight = centerConfig.lineHeight || 25;

          ctx.textAlign = "center";
          ctx.textBaseline = "middle";
          const centerX = (chart.chartArea.left + chart.chartArea.right) / 2;
          let centerY = (chart.chartArea.top + chart.chartArea.bottom) / 2;
          ctx.font = "500 16px " + fontStyle;
          ctx.fillStyle = color;
          const words = String(txt).split(" ");
          const lines = [];
          if (stringWidth > 70) {
            for (n = 0; n < words.length; n++) {
              lines.push(words[n]);
            }
            centerY -= (lines.length / 2) * lineHeight;
            for (n = 0; n < lines.length; n++) {
              ctx.fillText(lines[n], centerX, centerY + centerConfig?.paddingY ?? 0);
              centerY += lineHeight;
            }
          } else {
            ctx.fillText(txt, centerX, centerY + centerConfig?.paddingY ?? 0);
          }
          ctx.fillStyle = "#000";
        }
        if (chart.config.options?.plugins?.center?.subTitle) {
          let n;
          const ctx = chart.ctx;
          const centerConfig = chart.config.options.plugins.center.subTitle;
          const fontStyle = centerConfig.fontStyle || "Rubik";
          const txt = centerConfig.text;
          const color = centerConfig.color || "#000";

          // Get the width of the string and also the width of the element minus 10 to give it 5px side padding
          const stringWidth = ctx.measureText(txt).width;

          const lineHeight = centerConfig.lineHeight || 25;

          ctx.textAlign = "center";
          ctx.textBaseline = "middle";
          const centerX = (chart.chartArea.left + chart.chartArea.right) / 2;
          let centerY = (chart.chartArea.top + chart.chartArea.bottom) / 2;
          ctx.font = "15px " + fontStyle;
          ctx.fillStyle = color;
          const words = String(txt)
            .split(",")
            .map((x) => x + ",");
          const lines = [];
          if (stringWidth > 200) {
            for (n = 0; n < words.length; n++) {
              lines.push(words[n]);
            }
            centerY -= (lines.length / 2) * lineHeight;
            for (n = 0; n < lines.length; n++) {
              ctx.fillText(lines[n], centerX, 20 + centerY + centerConfig?.paddingY ?? 0);
              centerY += lineHeight;
            }
          } else {
            ctx.fillText(txt, centerX, centerY + centerConfig?.paddingY ?? 0);
          }
          ctx.fillStyle = "#000";
        }
      },
    });
  }
});
